import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Login.scss';

const SubscriptionCancelledPage: React.FC = () => {
  const { logout, currentUser } = useAuth();

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card-header">
          <img src="/assets/branding/rc-logo-dark.png" alt="Reality Coach" className="login-logo" />
          <h1 className="login-title">Subscription Cancelled</h1>
          {currentUser?.email && (
            <p className="login-subtitle">Signed in as <strong>{currentUser.email}</strong></p>
          )}
        </div>

        <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '1.25rem', textAlign: 'center' }}>
          Your Google Cloud Marketplace subscription has been cancelled or is no longer active.
          To restore access, please reactivate your subscription in the GCP Console.
        </p>

        <div style={{
          background: '#fef2f2',
          border: '1px solid #fca5a5',
          borderRadius: '8px',
          padding: '0.75rem 1rem',
          marginBottom: '1.5rem',
        }}>
          <p style={{ color: '#991b1b', fontSize: '0.8125rem', lineHeight: '1.5', margin: '0 0 6px' }}>
            Access to Reality Coach requires an active Google Cloud Marketplace subscription.
            Your data is preserved and will be available once your subscription is reactivated.
          </p>
          <p style={{ margin: 0, fontSize: '0.8125rem', color: '#991b1b' }}>
            Need help?{' '}
            <a href="mailto:tech@realitycoach.ai" style={{ color: '#005581', fontWeight: '600', textDecoration: 'none' }}>
              tech@realitycoach.ai
            </a>
          </p>
        </div>

        <a
          href="https://console.cloud.google.com/marketplace/product/da-realitycoach-prod/reality-coach"
          target="_blank"
          rel="noopener noreferrer"
          className="login-btn login-btn--primary"
          style={{ display: 'block', textAlign: 'center', textDecoration: 'none', marginBottom: '0.75rem' }}
        >
          Reactivate in GCP Console
        </a>

        <button className="login-btn" style={{ width: '100%', background: 'transparent', border: '1px solid #d1d5db', color: '#374151', padding: '0.625rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' }} onClick={() => logout()}>
          Log Out
        </button>
      </div>
    </div>
  );
};

export default SubscriptionCancelledPage;
